<template>
  <div class="event-handling-container">
    <!-- 标题区域 - 带渐变背景 -->
    <div class="event-title">
      事件介入处理
    </div>

    <!-- 选项列表 -->
    <div class="options-list">
      <div
          v-for="(item, index) in options"
          :key="index"
          :class="['option-item', { 'active': activeIndex === index }]"
          @click="handleOptionClick(index)"
      >
        <span :class="item.colorClass"></span>
        <span class="option-text">{{ item.name }}</span>
        <i class="el-icon-arrow-right" v-if="activeIndex === index"></i>
      </div>
    </div>
  </div>
</template>

<script>
import {Message} from "element-ui";

export default {
  data() {
    return {
      activeIndex: 1,
      options: [
        { name: '公共安全感知', colorClass: 'blue-dot' },
        { name: '投诉建议', colorClass: 'orange-dot' },
        { name: '处理记录', colorClass: 'blue-dot' }
      ]
    };
  },
  methods: {
    handleOptionClick(index) {
      if (index==1 || index==2) {
        this.activeIndex = index;
      }else{
        Message.info('功能开发中，敬请期待！');
      }
      // 向父组件发送事件
      this.$emit('option-change', index);
    }
  }
};
</script>


<style scoped>
.event-handling-container {
  width: 300px; /* 可根据需要调整宽度 */
  background-color: transparent; /* 深色背景 */
  border-radius: 4px;
  overflow: hidden;
}

/* 标题样式 - 渐变背景 */
.event-title {
  padding: 16px 20px;
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
  /* 蓝绿色渐变背景 */
  background-image: linear-gradient(135deg, #016565, #0a2442);
  clip-path: polygon(0 0, 70% 0%, 100% 100%, 0 100%);

}

.options-list {
  padding: 10px;
  border: 1px solid #1e9893;
}

/* 选项项基础样式 */
.option-item {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  margin-bottom: 8px;
  color: #ffffff;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

/* 选中状态样式 */
.option-item.active {
  background-color: rgba(0, 153, 153, 0.2);
  border-color: #00cccc;
}

/* 圆点样式 */
.blue-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #00ccff;
  margin-right: 10px;
}

.orange-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ff9933;
  margin-right: 10px;
}

.option-text {
  flex: 1;
}

/* 箭头图标样式 */
.el-icon-arrow-right {
  color: #00cccc;
  font-size: 16px;
}
</style>
